import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface StopCanceledFieldsProps extends React.SVGProps<SVGSVGElement> {
  isSelected?: boolean;
}

export default function StopCanceledFields({ isSelected = false, style, onClick }: StopCanceledFieldsProps) {
  return (
    <SvgIcon onClick={onClick} viewBox="0 0 26 26" style={{ width: `24px`, height: `24px`, ...(style ?? {}) }}>
      <g>
        {!isSelected ? (
          <g>
            <path
              fill={RoutalPalette.neutral60}
              d="m20.83,25.77H5.16c-2.63,0-4.77-2.14-4.77-4.77V5.01C.39,2.38,2.53.23,5.16.23h15.67c2.63,0,4.78,2.14,4.78,4.77v15.98c0,2.63-2.14,4.77-4.78,4.77ZM5.16,1.23c-2.08,0-3.77,1.69-3.77,3.77v15.98c0,2.08,1.69,3.77,3.77,3.77h15.67c2.08,0,3.78-1.69,3.78-3.77V5.01c0-2.08-1.69-3.77-3.78-3.77H5.16Z"
            />
            <path
              fill={RoutalPalette.neutral60}
              d="m13.95,12.96l3.86-3.86c.23-.27.19-.68-.08-.91-.24-.2-.58-.2-.82,0l-3.86,3.86-3.86-3.86c-.27-.23-.68-.19-.91.08-.2.24-.2.58,0,.82l3.86,3.87-3.86,3.86c-.27.23-.31.63-.08.91.23.27.63.31.91.08.03-.02.06-.05.08-.08l3.86-3.86,3.86,3.86c.27.23.68.19.91-.08.2-.24.2-.58,0-.82l-3.86-3.86Z"
            />
          </g>
        ) : (
          <g>
            <rect fill={RoutalPalette.primary40} x=".39" y=".23" width="25.22" height="25.53" rx="4.78" ry="4.78" />
            <path
              fill={RoutalPalette.neutral00}
              d="m13.95,12.96l3.86-3.86c.23-.27.19-.68-.08-.91-.24-.2-.58-.2-.82,0l-3.86,3.86-3.86-3.86c-.27-.23-.68-.19-.91.08-.2.24-.2.58,0,.82l3.86,3.87-3.86,3.86c-.27.23-.31.63-.08.91.23.27.63.31.91.08.03-.02.06-.05.08-.08l3.86-3.86,3.86,3.86c.27.23.68.19.91-.08.2-.24.2-.58,0-.82l-3.86-3.86Z"
            />
          </g>
        )}
      </g>
    </SvgIcon>
  );
}
